Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.EventLogNotes = Greenmile.EventNotifications.EventLogNotes || {};
Greenmile.EventNotifications.EventLogNotes.TableView = Greenmile.EventNotifications.EventLogNotes.TableView || {};

Greenmile.EventNotifications.EventLogNotes.TableView = (function () {

    function EventLogNotesTableView (eventLogNotes) {

        this.getEventLogNotesTabContent = function () {
            const allContent = document.createElement('div');
            const divEventLogNotes = document.createElement('div');
            divEventLogNotes.className = 'eventLogNotesTableViewEventLogNotesData';
            divEventLogNotes.appendChild(this.getEventLogNotesContent());
            allContent.appendChild(this.getEventLogNotesContent());

            return allContent;
        };

        this.getEventLogNotesContent = function () {

            const getTabLines = () => {
                return eventLogNotes.map(eventLogNote => ({
                date: eventLogNote.noteTime,
                comments: eventLogNote.comment,
                userKey: eventLogNote.user.key,
                username: eventLogNote.user.name
                }));           
            }
            const grid = new Greenmile.UI.CommentsTableView(getTabLines()); 
            return grid.render();
        };

    }

    return EventLogNotesTableView;

})();